import React from "react";
import {
  DemoResponsiveGrid,
  DemoWorkbenchCard,
  DemoWorkbenchCopy,
  DemoWorkbenchMetricCard,
  DemoWorkbenchStack,
  NumberTicker,
  ProgressBar,
} from "@csk/demo-ui";
import {
  GOVERNANCE_HEALTH_BLOCKS,
  determinantMarginPercent,
  summarizeGovernanceHealth,
} from "./governance-health-panel/governanceHealthModel.js";

const GovernanceHealthPanel = (): React.JSX.Element => {
  const blocks = GOVERNANCE_HEALTH_BLOCKS;
  const summary = summarizeGovernanceHealth(blocks);

  return (
    <DemoWorkbenchStack>
      <DemoWorkbenchMetricCard
        label="Overall status"
        value="IN GL(n)"
        color="#22c55e"
        sub={
          <>
            det ={" "}
            <NumberTicker value={summary.overallDeterminant} precision={2} /> ·
            most fragile: {summary.worstBlock.name} (κ=
            {summary.worstBlock.conditionNumber.toFixed(1)})
          </>
        }
      />

      <DemoWorkbenchStack gap={8}>
        {blocks.map((block) => {
          const determinantWidth = determinantMarginPercent(block);
          return (
            <DemoWorkbenchCard key={block.name} compact title={block.name}>
              <div className="mb-1 flex justify-between text-sm">
                <DemoWorkbenchCopy tone="muted">
                  det={block.determinant.toFixed(2)} · κ=
                  {block.conditionNumber.toFixed(1)} · {block.fragility}
                </DemoWorkbenchCopy>
              </div>
              <ProgressBar
                value={determinantWidth}
                tone={block.fragility === "ROBUST" ? "success" : "warning"}
                height={8}
                ariaLabel={`${block.name} determinant margin`}
              />
              <DemoWorkbenchCopy size="xs" tone="muted" className="mt-1">
                If singular: {block.singularityMeaning}
              </DemoWorkbenchCopy>
            </DemoWorkbenchCard>
          );
        })}
      </DemoWorkbenchStack>

      <DemoResponsiveGrid minColumnWidth={240} gap={8}>
        <DemoWorkbenchCard compact title="Pre-Singularity Timeline">
          <DemoWorkbenchCopy tone="bright">
            No blocks approaching singularity
          </DemoWorkbenchCopy>
          <DemoWorkbenchCopy size="xs" tone="muted" className="mt-1">
            All condition numbers &lt; 100. BOP conservation: automatic (theorem
            of GL(n)).
          </DemoWorkbenchCopy>
        </DemoWorkbenchCard>
      </DemoResponsiveGrid>
    </DemoWorkbenchStack>
  );
};

export default GovernanceHealthPanel;
